import { IRootState } from '../redux/state';
import { locale } from '../common/localization/localizationService';
import { IAuthState, UserRoles } from '../redux/modules/auth';
import { IUser } from '../models';
import {
  faCheck,
  faMinus,
  faTimes,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';

export const convertStringToBoolean = (value: string): boolean => {
  return value === 'true';
};

export const isDataFetching = (
  state: IRootState,
  component: string,
): boolean => {
  if (!state.loading?.loadingInProgress?.length) {
    return false;
  } else if (state.loading?.loadingInProgress?.length > 0) {
    for (let i = 0; i < state.loading.loadingInProgress.length; i++) {
      if (
        state.loading.loadingInProgress[i]
          .toLowerCase()
          .includes(component.toLocaleLowerCase())
      ) {
        return true;
      }
    }
  }
  return false;
};
export function getDirectMessageStatus(status: number): string {
  switch (status) {
    case 0:
      return locale.directMessages._sent;
    case 1:
      return locale.directMessages._received;
    case 2:
      return locale.directMessages._read;
    default:
      return '';
  }
}

export function getOrderStatus(status: number): string {
  switch (status) {
    case 0:
      return locale.orders.status._noDone;
    case 1:
      return locale.orders.status._okDone;
    case 2:
      return locale.orders.status._downloaded;
    case 3:
      return locale.orders.status._started;
    case 4:
      return locale.orders.status._backOrder;
    case 5:
      return locale.orders.status._localBackOrder;
    case 6:
      return locale.orders.status._partiallyStarted;
    case 7:
      return locale.orders.status._partiallyCompleted;
    case 8:
      return locale.orders.status._rejected;
    case 10:
      return locale.orders.status._planned;
    case 99:
      return locale.orders.status._deleted;
    default:
      return '';
  }
}

export function getCustomerIdInUse(authentication: IAuthState | IUser): number {
  const customerId = authentication.impersonatedCustomerId
    ? authentication.impersonatedCustomerId
    : authentication.customerId;
  return customerId;
}

// To avoid time zone troubles
export function toLocalDateTimeString(date: Date): string {
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate(),
  )}T00:00:00`;
}

export const hasRole = (
  userRole: string,
  requiredRoles: UserRoles[],
): boolean => {
  const roles = userRole.split(',').map((r) => r.trim());
  if (roles.some((r) => r.toUpperCase() === UserRoles.SUPERADMINISTRATOR)) {
    return true;
  }
  if (
    requiredRoles.some(
      (rr) => rr.toLocaleUpperCase() === UserRoles.SUPERADMINISTRATOR,
    )
  ) {
    return false;
  }
  if (roles.some((r) => r.toUpperCase() === UserRoles.ADMINISTRATOR)) {
    return true;
  }
  const isPermitted = roles.some((r) =>
    requiredRoles.some((rr) => r.toUpperCase() === rr),
  );
  return isPermitted;
};

export const getExecutedIcon = (statusMessage: string): IconDefinition => {
  switch (statusMessage) {
    case 'Ja':
      return faCheck;
    case 'Nei':
      return faTimes;
    default:
      return faMinus;
  }
};

export const diffTime = (d1: Date, d2: Date): string => {
  const diffMs = Math.abs(d2.getTime() - d1.getTime());

  const h = Math.floor(diffMs / 3600000);
  const m = Math.floor((diffMs % 3600000) / 60000);
  const s = Math.floor((diffMs % 60000) / 1000);

  return [
    String(h).padStart(2, '0'),
    String(m).padStart(2, '0'),
    String(s).padStart(2, '0'),
  ].join(':');
};

export const diffMinutes = (d1: Date, d2: Date): number => {
  const diffMs = Math.abs(d2.getTime() - d1.getTime());
  return diffMs / 60000;
};
